import { chatsWebsocketEndpoint } from "../../data/endpoint";

export const createWebSocket = ({ token, onOpen, onClose, onMessage }) => {
  const endpoint = chatsWebsocketEndpoint + "?token=" + token;
  const socket = new WebSocket(endpoint);
  socket.addEventListener("open", () => {
    console.log("Socket opened");
    onOpen();
  });
  socket.addEventListener("message", ({ data }) => onMessage(JSON.parse(data)));
  socket.addEventListener("error", e => {
    console.error("@websocket [ERROR] => ", e);
  });
  socket.addEventListener("close", e => {
    console.error("@websocket [CLOSE] => ", e);
    onClose(e);
  });

  return socket;
};

export const sendWebSocketMessage = ({ socket, message, action }) => {
  const json = JSON.stringify({
    action,
    data: message
  });
  socket.send(json);
};
